import { Autocomplete, Button, Input, keyframes, styled } from '@mui/material';

const showFilter = keyframes`
  100% {
    top: 0;
  }
`;

export const ContainerStyled = styled('div')(({ openFilter }) => ({
  position: 'fixed',
  height: '100vh',
  overflowY: 'scroll',
  top: '100%',
  left: 0,
  opacity: 0,
  ...(openFilter && {
    opacity: 1,
    top: 0,
    transition: '1s all',
    animation: `${showFilter} 500ms all`,
  }),
}));

export const MobileFilterStyled = styled('div')({
  background: 'white',
  width: '100vw',
  maxWidth: '100%',
  zIndex: 999,
  padding: '1rem',
});

export const FilterHeadStyled = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '30px',
});

export const BackBtnStyled = styled(Button)(({ theme }) => ({
  border: 'none',
  outline: 'none',
  background: 'transparent',
  color: theme.palette.secondary.main,
}));

export const ClearBtnStyled = styled(Button)(({ theme }) => ({
  padding: '10px 14px',
  fontFamily: 'Montserrat',
  fontSize: '15px',
  color: theme.palette.global.white,
  background: theme.palette.secondary.main,
  border: 'none',
  outline: 'none',
  borderRadius: '4px',
  textTransform: 'uppercase',
}));

export const FormStyled = styled('form')({
  marginTop: '32px',
});

export const ContainerInputsStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '30px',
  marginBottom: '16px',
});

export const LabelStyled = styled('label')({
  fontSize: '14px',
  lineHeight: '18px',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  marginBottom: '5px',
  display: 'inline-block',
});

export const TextFieldsStyled = styled(Input)({
  border: '2px solid #707070',
  borderRadius: '4px',
});

export const CustomInputDateStyled = styled('div')({
  border: '2px solid #707070',
  width: '100%',
  borderRadius: '4px',
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
});

export const CustomInputStyled = styled('input')(({ theme }) => ({
  border: 'none',
  height: 38,
  width: 165,
  padding: 12,
  fontSize: 13,
  outline: 'none',
  fontFamily: 'montserrat',
  backgroundColor: theme.palette.global.white,
}));

export const TextFieldAutoCompleteStyled = styled(Autocomplete)({
  border: '2px solid #707070',
  borderRadius: '4px',
});

export const ContainerButtonsStyled = styled('div')({
  width: '100%',
});

export const BtnFilterStyled = styled(Button)(({ theme }) => ({
  width: '100%',
  background: theme.palette.primary.main,
  color: theme.palette.secondary.main,
  padding: '10px',
  margin: '40px 0',
}));
